import { defaultMenu, getMenu, Menu } from "domain/menuOptions";
import { action } from "mobx";
import { StoreBase } from "./storeBase";

export class MenuStore extends StoreBase<Menu[]> {
  constructor() {
    super(() => defaultMenu());
  }

  @action setMenu = (menu: Menu) => (this.data = getMenu(menu));
  @action setDefaultMenu = () => (this.data = defaultMenu());
}
